// src/pages/Workers/Documents/ExportDocumentsPDF.jsx
import React from "react";
import { Document, Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const styles = StyleSheet.create({
  page: { padding: 30, fontSize: 12, fontFamily: "Helvetica", color: "#101828" },
  heading: { textAlign: "center", fontSize: 18, fontWeight: "bold", marginBottom: 20, color: "#003149" },
  recordGroup: { marginBottom: 12, paddingBottom: 8, borderBottomWidth: 1, borderBottomColor: "#ccc", borderBottomStyle: "solid" },
  row: { flexDirection: "row", justifyContent: "space-between", marginBottom: 6 },
  label: { color: "#344054", fontWeight: "bold" },
  value: { color: "#101828" },
});

const ExportDocumentsPDF = ({ data, logo }) => {
  const { t } = useTranslation();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        
        {logo && (
          <Image
            src={logo}
            style={{ width: 140, alignSelf: "center", marginBottom: 10 }}
          />
        )}

        <Text style={styles.heading}>  {t("documents.myDocuments") || "My Documents"}</Text>

        {data.map((doc, idx) => (
          <View key={idx} style={styles.recordGroup}>

            <View style={styles.row}>
              <Text style={styles.label}>{t("documents.th.id") || "ID"}:</Text>
              <Text style={styles.value}>{doc.id}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("documents.th.documentName") || "Document Name"}:</Text>
              <Text style={styles.value}>{doc.documentName}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("documents.th.description") || "Description"}:</Text>
              <Text style={styles.value}>{doc.description}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("documents.th.subject") || "Subject"}:</Text>
              <Text style={styles.value}>{doc.subject}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("documents.th.fileType") || "File Type"}:</Text>
              <Text style={styles.value}>{doc.fileType}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("documents.th.status") || "Status"}:</Text>
              <Text style={styles.value}>{doc.status}</Text>
            </View>

            <View style={styles.row}>
              <Text style={styles.label}>{t("documents.th.uploadedAt") || "Uploaded At"}:</Text>
              <Text style={styles.value}>{doc.date}</Text>
            </View>

          </View>
        ))}

      </Page>
    </Document>
  );
};

export default ExportDocumentsPDF;
